<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Stat from "@/components/widgets/widget-stat";
import Activity from "@/components/widgets/activity";
import {sparklineChartData, salesDonutChart, radialBarChart} from "./data";
import {CONSTANTS} from "@/helpers/constants";
import moment from "moment";
import {dashboardModel} from "@/models/dashboardModel";
import ListFile from "@/pages/hopThu/listFile";
import {CURRENT_USER} from "@/helpers/currentUser";

export default {
  page: {
    title: "Bảng điều khiển",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    Layout,
    Stat,
    // Activity,
    ListFile
  },
  data() {
    return {
      sparklineChartData: sparklineChartData,
      salesDonutChart: salesDonutChart,
      radialBarChart: radialBarChart,
      currentUserName: CURRENT_USER.USERNAME,
      apiUrl: process.env.VUE_APP_API_URL,
      statData: [
        {
          title: "Xử lý văn bản đến",
          image: require("@/assets/images/dashboard/folder-green.svg"),
          value: "0",
          subText: "VBD",
          color: "white",
          path: "/xu-ly-van-ban-den",
          className: "card-vanbanden",
          icon: "mdi-file text-primary"
        },
        {
          title: "Ban hành văn bản",
          image: require("@/assets/images/dashboard/Document.svg"),
          value: "0",
          subText: "VBD",
          color: "white",
          path: "/xu-ly-van-ban-di",
          className: "card-vanbandi",
          icon: "mdi-book-arrow-left text-success"
        },
        {
          title: "Hộp thư",
          image: require("@/assets/images/dashboard/Message.svg"),
          value: "0",
          subText: "VBDXL",
          color: "white",
          path: "/thu-den",
          className: "card-hopthu",
          icon: "mdi-email text-danger"
        },
        {
          title: "Thông báo",
          image: require("@/assets/images/dashboard/Notification.svg"),
          value: "0",
          subText: "HT",
          color: "white",
          path: "/merge-thongbao",
          className: "card-thongbao",
          icon: "mdi-bell text-warning"
        }
      ],
      lichCongTacCaNhan: null,
      lichCongTacDonVi: null,
      lichCongTacTruong: null,
      isCollapse: true,
      isCollapseCaNhan: true,
      isCollapseDonVi: true,
      modelSoLieu: dashboardModel.baseJson(),
      activityUserData: [],
      userLogins: [],
      showListFile: false,
      listFiles: [],
      showModalChiTietLCT: false,
      chiTietCongViec: null,
      url: process.env.VUE_APP_API_URL + 'files/view/',
      showModalThanhPhanKhacLCT: false,
      thanhPhanKhac: null,
    };
  },
  async created() {
    this.myProviderLichCongTacTruong();
    this.myProviderLichCongTacDonVi();
    this.myProviderLichCongCaNhan();
    this.soLieuDashboard();
    // this.getUserLogin();
  },
  methods: {
    checkThanhPhanLichCongTac(item) {
      if (item) {
        if (item.chuTri && item.chuTri.length > 0) {
          let check = item.chuTri.find(x => x.userName == this.currentUserName);
          if (check)
            return true;
        }
        if (item.thanhPhanThamDu && item.thanhPhanThamDu.length > 0) {
          let check = item.thanhPhanThamDu.find(x => x.userName == this.currentUserName);
          if (check)
            return true;
        }
      }
      return false;
    },
    showChiTietLCT(cv) {
      this.showModalChiTietLCT = true
      this.chiTietCongViec = cv;
    },
    showThanhPhanKhacLCT(cv) {
      this.showModalThanhPhanKhacLCT = true
      this.chiTietCongViec = cv;
    },
    handleShowListFile(files) {
      this.showListFile = true;
      this.listFiles = files;
    },
    soLieuDashboard() {
      try {
        this.$store.dispatch("dashboardStore/getDashboard").then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            this.modelSoLieu = resp.data;
            if (this.modelSoLieu) {
              this.statData[0].value = this.modelSoLieu.soCVDen.toString();
              this.statData[1].value = this.modelSoLieu.soCVDi.toString();
              this.statData[2].value = this.modelSoLieu.soThu.toString();
              this.statData[3].value = this.modelSoLieu.soThongBao.toString();
            }
            return;
          } else {
            return null;
          }
        })
      } finally {
        console.log()
      }
    },
    getUserLogin() {
      try {
        this.$store.dispatch("dashboardStore/getUserLogin").then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            this.userLogins = resp.data;
            return;
          } else {
            return null;
          }
        })
      } finally {
        console.log()
      }
    },
    myProviderLichCongTacTruong() {
      try {
        this.$store.dispatch("lichCongTacStore/getPaging", {
          loaiLichCongTac: 'lctt',
          selectDay: moment().format("DD/MM/YYYY")
        }).then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            this.lichCongTacTruong = resp.data;
            return;
          } else {
            return null;
          }
        })
      } finally {
        console.log()
      }
    },
    myProviderLichCongTacDonVi() {
      try {
        this.$store.dispatch("lichCongTacStore/getPaging", {
          loaiLichCongTac: 'lctdv',
          selectDay: moment().format("DD/MM/YYYY")
        }).then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            this.lichCongTacDonVi = resp.data;
            return;
          } else {
            return null;
          }
        })
      } finally {
        console.log()
      }
    },
    myProviderLichCongCaNhan() {
      try {
        this.$store.dispatch("lichCongTacStore/getPaging", {
          loaiLichCongTac: null,
          selectDay: moment().format("DD/MM/YYYY")
        }).then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            this.lichCongTacCaNhan = resp.data;
            return;
          } else {
            return null;
          }
        })
      } finally {
        console.log()
      }
    },
    formatDateLCT(cv){
      let date = "";
      if(cv.tuNgay != null && (cv.denNgay == null || (cv.denNgay != null && cv.tuNgay == cv.denNgay))){
        if(cv.thoiGian != null){
          date += `${cv.thoiGian}`;
        }
        if(cv.thoiGian != null && cv.thoiGianDenNgay != null)
        {
          date += " - ";
        }
        if(cv.thoiGianDenNgay != null){
          date += `${cv.thoiGianDenNgay}`;
        }
      }else{
        if(cv.tuNgay != null){
          date += `${cv.tuNgay}`
        }
        if(cv.thoiGian != null){
          date += ` ${cv.thoiGian}`
        }
        date += " - "
        if(cv.denNgay != null){
          date += `${cv.denNgay}`
        }
        if(cv.thoiGianDenNgay != null){
          date += ` ${cv.thoiGianDenNgay}`
        }
      }
      return date;
    }
  }
};
</script>

<template>
  <Layout>
    <!-- start page title -->
    <div class="row px-2 mt-2">
      <div class="col-12 ">
        <div class="card bg-dashboard mb-3">
          <div class="card-body">
            <div class="row px-2 equal-height-row ">
              <div class="col-sm-6">
                <div class="h-100 text-start">
                  <p class="font-size-18 text-white mb-4"> Chào mừng đến với hệ thống <span
                      class="fw-bold"> D-OFFICE</span></p>
                  <div>
                    <h4 class="title-dashboard mb-0">Hệ thống hành chính số Đại học Đồng Tháp</h4>
                  </div>
                  <div class="d-block">
                    <b-button target="_blank" href="http://dthu.edu.vn" class="btn btn-home me-2">
                      <i class="fas fa-home"></i>
                      Trang chủ DTHU
                    </b-button>
                    <!--                    <b-button class="btn btn-info">-->
                    <!--                      <i class="fas fa-info"></i>-->
                    <!--                      Thông tin bản quyền-->
                    <!--                    </b-button>-->

                    <!--                    <b-dropdown right class="dropdown-menu-dashboard" menu-class="dropdown-menu-start">-->
                    <!--                      <template v-slot:button-content>-->
                    <!--                        <i class="mdi mdi-cog me-2"></i> Truy cập nhanh-->
                    <!--                      </template>-->
                    <!--                      <b-dropdown-item href="http://dthu.edu.vn" target="_blank"> Trang chủ DThU</b-dropdown-item>-->
                    <!--                      <b-dropdown-item> Thông tin bản quyền</b-dropdown-item>-->
                    <!--                    </b-dropdown>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end page title -->
    <div class="row px-2 equal-height-row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-md-3 col-sm-6 col-12 pb-2 mb-2" v-for="stat of statData" :key="stat.icon">
            <Stat :title="stat.title" :image="stat.image" :subText="stat.subText" :value="stat.value"
                  :color="stat.color"
                  :path="stat.path" :icon="stat.icon" :className="stat.className"/>
          </div>
        </div>
      </div>
      <!--      <div class="col-lg-4 col-md-12" >-->
      <!--        <Activity :activityUserData="userLogins" />-->
      <!--      </div>-->
    </div>
    <div class="row px-2">
      <div class="col-lg-12 col-md-12">
        <section v-if="lichCongTacTruong">
          <b-card class="card-lichcongtac p-1">
            <div class="d-flex align-items-center mb-2 justify-content-between flex-wrap">
              <h5 style="font-weight: bold;" class="title-capso text-dark">
                <i class="mdi mdi-tag text-dark mdi-rotate-135 me-2"></i>
                Lịch công tác trường
              </h5>
<!--              <div class="cs-btn-lct">-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-star me-1"></i>Sự kiện mới-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-calendar-month me-1"></i>Hôm-->
<!--                  nay-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-chevron-left me-1"></i>Trở về-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-chevron-right me-1"></i>Tiếp-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-file-excel-outline me-1"></i>Xuất-->
<!--                  Excel-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-printer me-1"></i>In lịch-->
<!--                </b-button>-->
<!--              </div>-->

            </div>
            <div v-if="lichCongTacTruong && lichCongTacTruong.length > 0">
              <div v-for="(item, index) in lichCongTacTruong" :key="index" class="mb-3">
                <b-card-header v-if="item" class="fw-bold text-white bg-primary d-flex justify-content-between w-100">
                  <div>
                    <i class="fas fa-calendar-alt me-1"></i>
                    {{ item.ngayXepLich }}
                  </div>

                  <button v-b-toggle="'collapse-' + index" @click="isCollapse = !isCollapse" type="button" size="sm"
                          class="btn btn-outline btn-sm" data-toggle="tooltip" data-placement="bottom"
                          title="Xem chi tiết lịch">

                    <i v-if="isCollapse" class="fas fa-chevron-up text-white me-1"></i>
                    <i v-else class="fas fa-chevron-down text-white me-1"></i>
                  </button>
                </b-card-header>
                <b-collapse visible :id="'collapse-' + index" accordion="my-accordion" role="tabpanel">
                  <!--              Table -->
                  <div class="table-responsive mb-0">
                    <table style="margin: 0px" class="table table-bordered cs-table-dashboard">
                      <thead>
                      <tr>
                        <th width="150px" class="title-capso">Người chủ trì</th>
                        <th class="text-center title-capso" width="100px">Thời gian</th>
                        <th class="title-capso">Nội dung</th>
                        <th class="title-capso" width="20%">Địa điểm</th>
                        <th class="title-capso" width="20%">Thành phần</th>
                        <th class="title-capso" width="10%">Ghi chú</th>
                        <th class="title-capso" width="10%">Tệp tin</th>
                      </tr>
                      </thead>
                      <tbody v-if="item">
                      <tr v-for="(cv, index) in item.congViecs" :key="index">
                        <td v-if="cv.rowSpan > 0" :rowspan="`${cv.rowSpan}`"
                            style="vertical-align : middle;text-align:left;" class="pd-custom-2">
                          <div v-for="(value, index) in cv.chuTri" :key="index" class="text-uppercase fw-bold ms-1">
                            {{ value.fullName }}
                          </div>
                        </td>
                        <td class="text-center" style="vertical-align : middle;text-align:left;">
                          {{formatDateLCT(cv)}}
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div v-if="cv.noiDung">
                            <a class="cs-cursor lines" @click="showChiTietLCT(cv)" :inner-html.prop="cv.noiDung"></a>
                          </div>
                          <div v-if="cv.noiDung" class="text-end">
                            <a @click="showChiTietLCT(cv)" class="badge badge-soft-info cs-cursor"><i
                                class="fas fa-eye"></i> Xem
                              chi tiết</a>
                          </div>
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div v-if="cv.diaDiem" :inner-html.prop="cv.diaDiem">
                          </div>
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div v-if="cv.thanhPhanThamDu">
                            <div class="title-capso">Thành phần tham dự:</div>
                            <div class="d-flex justify-content-start py-1">
                            <span v-for="(value, index) in cv.thanhPhanThamDu" :key="index">
                              <span v-if="index <= 4" class="badge badge-soft-success me-1 font-size-13">
                                {{ value.fullName }}
                              </span>
                            </span>
                            </div>

                          </div>
                          <div v-if="cv.thanhPhan || cv.thanhPhanThamDu">
                            <div class="title-capso">Thành phần khác:</div>
                            <div class="lines" v-if="cv.thanhPhan" :inner-html.prop="cv.thanhPhan">
                            </div>
                            <div v-if="cv.thanhPhan || cv.thanhPhanThamDu" class="text-end">
                              <a @click="showThanhPhanKhacLCT(cv)" class="badge badge-soft-info cs-cursor"><i
                                  class="fas fa-eye"></i> Xem chi tiết</a>
                            </div>
                          </div>
                        </td>
                        <td style="vertical-align : middle;text-align:left;">
                          <div class="lines" v-if="cv.ghiChu" :inner-html.prop="cv.ghiChu">
                          </div>
                        </td>
                        <td style="vertical-align : middle;text-align:center;">
                          <div v-if="checkThanhPhanLichCongTac(cv) && cv.files && cv.files.length > 0">
                            <a href="javascript:void(0)" @click="handleShowListFile(cv.files)">
                              <i class="fas fa-cloud-download-alt"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </b-collapse>
              </div>
            </div>
            <div v-else>
              <b-alert show variant="success">
                <strong>Hôm nay!</strong> Không có lịch công tác.
              </b-alert>
            </div>

          </b-card>
        </section>
        <section v-if="lichCongTacDonVi">
          <b-card class="card-lichcongtac p-1">
            <div class="d-flex align-items-center mb-2 justify-content-between flex-wrap">
              <h5 style="font-weight: bold;" class="title-capso text-dark">
                <i class="mdi mdi-tag text-dark mdi-rotate-135 me-2"></i>
                Lịch công tác đơn vị
              </h5>
<!--              <div class="cs-btn-lct">-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-star me-1"></i>Sự kiện mới-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-calendar-month me-1"></i>Hôm-->
<!--                  nay-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-chevron-left me-1"></i>Trở về-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-chevron-right me-1"></i>Tiếp-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-file-excel-outline me-1"></i>Xuất-->
<!--                  Excel-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-printer me-1"></i>In lịch-->
<!--                </b-button>-->
<!--              </div>-->

            </div>
            <div v-if="lichCongTacDonVi && lichCongTacDonVi.length > 0">
              <div v-for="(item, index) in lichCongTacDonVi" :key="index">
                <b-card-header v-if="item" class="fw-bold text-white bg-primary"
                               style="display: flex; justify-content: space-between">
                  <div>
                    <i class="fas fa-calendar-alt me-1"></i>
                    {{ item.ngayXepLich }}
                  </div>
                  <button @click="isCollapseDonVi = !isCollapseDonVi" type="button" size="sm"
                          class="btn btn-outline btn-sm" :class="isCollapseDonVi ? null : 'collapsed'"
                          :aria-expanded="isCollapseDonVi ? 'true' : 'false'" aria-controls="collapse1"
                          data-toggle="tooltip"
                          data-placement="bottom" title="Xem chi tiết lịch">
                    <i v-if="isCollapseDonVi" class="fas fa-chevron-up text-white me-1"></i>
                    <i v-else class="fas fa-chevron-down text-white me-1"></i>
                  </button>
                </b-card-header>
                <b-collapse v-model="isCollapseDonVi" id="collapse1">
                  <!--              Table -->
                  <div class="table-responsive mb-0">
                    <table style="margin: 0px" class="table table-bordered table-responsive cs-table-dashboard">
                      <thead>
                      <tr>
                        <th width="150px" class="title-capso">Người chủ trì</th>
                        <th class="text-center title-capso" width="100px">Thời gian</th>
                        <th class="title-capso">Nội dung</th>
                        <th class="title-capso" width="20%">Địa điểm</th>
                        <th class="title-capso" width="20%">Thành phần</th>
                        <th class="title-capso" width="10%">Ghi chú</th>
                        <th class="title-capso" width="10%">Tệp tin</th>
                      </tr>
                      </thead>
                      <tbody v-if="item">
                      <tr v-for="(cv, index) in item.congViecs" :key="index">
                        <td v-if="cv.rowSpan > 0" :rowspan="`${cv.rowSpan}`"
                            style="vertical-align : middle;text-align:left;" class="pd-custom-2">
                          <div v-for="(value, index) in cv.chuTri" :key="index">
                            {{ value.fullName }}
                          </div>
                        </td>
                        <td class="text-center" style="vertical-align : middle;text-align:left;">
                          {{formatDateLCT(cv)}}
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div class="lines" v-if="cv.noiDung">
                            <a class="cs-cursor " @click="showChiTietLCT(cv)" :inner-html.prop="cv.noiDung"></a>
                          </div>
                          <div v-if="cv.noiDung" class="text-end">
                            <a @click="showChiTietLCT(cv)" class="badge badge-soft-info cs-cursor"><i
                                class="fas fa-eye"></i> Xem
                              chi tiết</a>
                          </div>
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div v-if="cv.diaDiem" :inner-html.prop="cv.diaDiem">
                          </div>
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div v-if="cv.thanhPhanThamDu">
                            <div class="title-capso text-black">Thành phần tham dự:</div>
                            <div class="d-flex justify-content-start flex-wrap">
                              <div
                                  v-for="(value, index) in cv.thanhPhanThamDu"
                                  :key="index"
                                  class="py-1"
                              >
                              <span v-if="index <= 4" class="badge badge-soft-success font-size-13 me-1">
                                {{ value.fullName }}
                              </span>
                              </div>
                            </div>
                          </div>
                          <div v-if="cv.thanhPhan || cv.thanhPhanThamDu">
                            <div class="title-capso text-black">Thành phần khác:</div>
                            <div class="lines" v-if="cv.thanhPhan" :inner-html.prop="cv.thanhPhan">
                            </div>
                            <div v-if="cv.thanhPhan || cv.thanhPhanThamDu" class="text-end">
                              <a @click="showThanhPhanKhacLCT(cv)" class="badge badge-soft-info cs-cursor"><i
                                  class="fas fa-eye"></i> Xem chi tiết</a>
                            </div>
                          </div>
                        </td>
                        <td style="vertical-align : middle;text-align:left;">
                          <div class="lines" v-if="cv.ghiChu" :inner-html.prop="cv.ghiChu">
                          </div>
                        </td>
                        <td style="vertical-align : middle;text-align:center;">
                          <div v-if="checkThanhPhanLichCongTac(cv) && cv.files && cv.files.length > 0">
                            <a href="javascript:void(0)" @click="handleShowListFile(cv.files)">
                              <i class="fas fa-cloud-download-alt"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </b-collapse>
              </div>
            </div>
            <div v-else>
              <b-alert show variant="success">
                <strong>Hôm nay!</strong> Không có lịch công tác.
              </b-alert>
            </div>
          </b-card>
        </section>
        <section v-if="lichCongTacCaNhan">
          <b-card class="card-lichcongtac p-1">
            <div class="d-flex align-items-center mb-2 justify-content-between flex-wrap">
              <h5 style="font-weight: bold;" class="title-capso text-dark">
                <i class="mdi mdi-tag text-dark mdi-rotate-135 me-2"></i>
                Lịch công tác cá nhân
              </h5>
<!--              <div class="cs-btn-lct">-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-star me-1"></i>Sự kiện mới-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-calendar-month me-1"></i>Hôm-->
<!--                  nay-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-chevron-left me-1"></i>Trở về-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-chevron-right me-1"></i>Tiếp-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-file-excel-outline me-1"></i>Xuất-->
<!--                  Excel-->
<!--                </b-button>-->
<!--                <b-button size="sm" variant="light" class="cs-btn-lct"><i class="mdi mdi-printer me-1"></i>In lịch-->
<!--                </b-button>-->
<!--              </div>-->
            </div>
            <div v-if="lichCongTacCaNhan && lichCongTacCaNhan.length > 0">
              <div v-for="(item, index) in lichCongTacCaNhan" :key="index">
                <b-card-header v-if="item" class="fw-bold text-white bg-primary"
                               style="display: flex; justify-content: space-between">
                  <div>
                    <i class="fas fa-calendar-alt me-1"></i>
                    {{ item.ngayXepLich }}
                  </div>

                  <button @click="isCollapseCaNhan = !isCollapseCaNhan" type="button" size="sm"
                          class="btn btn-outline btn-sm" :class="isCollapseCaNhan ? null : 'collapsed'"
                          :aria-expanded="isCollapseCaNhan ? 'true' : 'false'" aria-controls="collapse1"
                          data-toggle="tooltip"
                          data-placement="bottom" title="Xem chi tiết lịch">

                    <i v-if="isCollapseCaNhan" class="fas fa-chevron-up text-white me-1"></i>
                    <i v-else class="fas fa-chevron-down text-white me-1"></i>
                  </button>
                </b-card-header>
                <b-collapse v-model="isCollapseCaNhan" id="collapse1">
                  <!--              Table -->
                  <div class="table-responsive mb-0">
                    <table style="margin: 0px" class="table table-bordered table-responsive cs-table-dashboard">
                      <thead>
                      <tr>
                        <th width="150px" class="title-capso">Người chủ trì</th>
                        <th class="text-center title-capso" width="100px">Thời gian</th>
                        <th class="title-capso">Nội dung</th>
                        <th class="title-capso" width="20%">Địa điểm</th>
                        <th class="title-capso" width="20%">Thành phần</th>
                        <th class="title-capso" width="10%">Ghi chú</th>
                        <th class="title-capso" width="10%">Tệp tin</th>

                      </tr>
                      </thead>
                      <tbody v-if="item">
                      <tr v-for="(cv, index) in item.congViecs" :key="index">
                        <td v-if="cv.rowSpan > 0" :rowspan="`${cv.rowSpan}`"
                            style="vertical-align : middle;text-align:left;" class="pd-custom-2">
                          <div v-for="(value, index) in cv.chuTri" :key="index">
                            {{ value.fullName }}
                          </div>
                        </td>
                        <td class="text-center" style="vertical-align : middle;text-align:left;">
                          <!--                        <div v-if="cv.tuNgay && cv.denNgay">-->
                          <!--                          {{ cv.tuNgay }} - {{ cv.denNgay }}-->
                          <!--                        </div>-->
                          <!--                        <div v-else-if="cv.thoiGian">-->
                          <!--                          {{ cv.thoiGian }}-->
                          <!--                        </div>-->
                          <!--                        <div v-else>-->
                          <!--                          {{ cv.tuNgay }}-->
                          <!--                        </div>-->
                          {{formatDateLCT(cv)}}
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div v-if="cv.noiDung">
                            <a class="cs-cursor lines" @click="showChiTietLCT(cv)" :inner-html.prop="cv.noiDung"></a>
                          </div>
                          <div v-if="cv.noiDung" class="text-end">
                            <a @click="showChiTietLCT(cv)" class="badge badge-soft-info cs-cursor"><i
                                class="fas fa-eye"></i> Xem chi tiết</a>
                          </div>
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div v-if="cv.diaDiem" :inner-html.prop="cv.diaDiem">
                          </div>
                        </td>
                        <td class="pd-custom-2" style="vertical-align : middle;text-align:left;">
                          <div v-if="cv.thanhPhanThamDu">
                            <div class="title-capso">Thành phần tham dự:</div>
                            <div class="d-flex justify-content-start">
                            <span v-for="(value, index) in cv.thanhPhanThamDu" :key="index">
                              <span v-if="index <= 4" class="badge badge-soft-success me-1 font-size-13">
                                {{ value.fullName }}
                              </span>
                            </span>
                            </div>
                          </div>
                          <div v-if="cv.thanhPhan || cv.thanhPhanThamDu">
                            <div class="title-capso">Thành phần khác:</div>
                            <div class="lines" v-if="cv.thanhPhan" :inner-html.prop="cv.thanhPhan">
                            </div>
                            <div v-if="cv.thanhPhan || cv.thanhPhanThamDu" class="text-end">
                              <a @click="showThanhPhanKhacLCT(cv)" class="badge badge-soft-info cs-cursor"><i
                                  class="fas fa-eye"></i> Xem chi tiết</a>
                            </div>
                          </div>
                        </td>
                        <td style="vertical-align : middle;text-align:left;">
                          <div class="lines" v-if="cv.ghiChu" :inner-html.prop="cv.ghiChu">
                          </div>
                        </td>
                        <td style="vertical-align : middle;text-align:center;">
                          <div v-if="checkThanhPhanLichCongTac(cv) && cv.files && cv.files.length > 0">
                            <a href="javascript:void(0)" @click="handleShowListFile(cv.files)">
                              <i class="fas fa-cloud-download-alt"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </b-collapse>
              </div>
            </div>
            <div v-else>
              <b-alert show variant="success">
                <strong>Hôm nay!</strong> Không có lịch công tác.
              </b-alert>
            </div>
          </b-card>
        </section>
      </div>
    </div>
    <!--    List files-->
    <ListFile :show-modal.sync="showListFile" :files.sync="listFiles"></ListFile>
    <b-modal
        v-model="showModalChiTietLCT"
        centered
        title="Chi tiết công việc"
        title-class="font-18"
        no-close-on-backdrop
        size="xl"
        hide-header
        hide-footer
        modal-class="cs-modal-chitietLCT"
    >
      <div class="row">
        <div class="col-12 position-relative">
          <a class="cs-close-modal" @click="showModalChiTietLCT = false"><i class="mdi mdi-close-thick"></i></a>
        </div>
      </div>
      <div class="row px-3 mt-3" v-if="chiTietCongViec">
        <div class="col-xl-7 col-lg-12 col-md-12 border-right">
          <div>
            <div>
              <h5 class="text-bold text-black">Nội dung</h5>
            </div>
            <h3 v-if="chiTietCongViec.noiDung" class="text-black title-lct-modal" :inner-html.prop="chiTietCongViec.noiDung"></h3>
          </div>
          <div class="row cs-table-chitietLCT px-3">
            <div class="col-lg-6 col-md-12 mb-2">
              <div v-if="chiTietCongViec.diaDiem" class="d-flex align-items-start">
                <div>
                  <i class="mdi mdi-map-marker me-1 mdi-24px cs-icon"></i>
                </div>
                <div class="">
                  <p class="mb-1 cs-title">Địa điểm</p>
                  <p class="cs-content" :inner-html.prop="chiTietCongViec.diaDiem"></p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mb-2">
              <div v-if="chiTietCongViec.thoiGian" class="d-flex align-items-start">
                <div>
                  <i class="mdi mdi-timer me-1 mdi-24px cs-icon"></i>
                </div>
                <div class="">
                  <p class="mb-1 cs-title">Thời gian</p>
                  <p class="cs-content">{{ chiTietCongViec.thoiGian }}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mb-2">
              <div v-if="chiTietCongViec.tuNgay" class="d-flex align-items-start">
                <div>
                  <i class="mdi mdi-calendar-arrow-right me-1 mdi-24px cs-icon"></i>
                </div>
                <div class="">
                  <p class="mb-1 cs-title">Từ ngày</p>
                  <p class="cs-content">{{ chiTietCongViec.tuNgay }}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mb-2">
              <div v-if="chiTietCongViec.denNgay" class="d-flex align-items-start">
                <div>
                  <i class="mdi mdi-calendar-arrow-left me-1 mdi-24px cs-icon"></i>
                </div>
                <div class="">
                  <p class="mb-1 cs-title">Đến ngày</p>
                  <p class="cs-content">{{ chiTietCongViec.denNgay }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="chiTietCongViec.ghiChu" class="row mt-3">
            <div class="col-12">
              <div>
                <h5 class="text-bold text-black mb-2">Ghi chú:</h5>
                <p :inner-html.prop="chiTietCongViec.ghiChu"></p>
              </div>
            </div>
          </div>
          <div v-if="chiTietCongViec.files && chiTietCongViec.files.length > 0" class="row mt-3">
            <div class="col-12">
              <div>
                <h5 class="text-bold text-black mb-2">Văn bản đính kèm:</h5>
                <div>
                  <div
                      v-for="(value, index) in chiTietCongViec.files" :key="index"
                      class="px-2"
                      style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px; margin-bottom: 5px"
                  >
                    <a
                        :href="`${apiUrl}files/view/${value.fileId}`"
                        class=" fw-medium"
                    ><i
                        class="fas fa-cloud-download-alt"
                    ></i>
                      [Tải về]</a
                    >
                    <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-lg-12 col-md-12 px-4 " >
          <div id="scroll" class="cs-scroll">
            <div class="force-overflow">
              <!-- Thành phần chủ trì-->
              <div class="row mb-3">
                <div v-if="chiTietCongViec.chuTri" class="col-12">
                  <div>
                    <h5 class="text-bold text-black">Người chủ trì</h5>
                  </div>
                  <div v-if="chiTietCongViec.chuTri">
                    <div v-for="(chutri, index) in chiTietCongViec.chuTri" :key="index" class="cs-row">
                      <div class="row equal-height-row">
                        <div class="col-md-6 col-12">
                          <div class="row equal-height-row">
                            <div class="col-3 justify-content-center">
                        <span v-if="chutri.avatar">
                          <b-img
                              :src=" url + `${chutri.avatar.fileId}`"
                              alt="Avatar"
                              class="rounded-circle header-profile-user"
                          >
                          </b-img>
                        </span>
                              <span v-else>
                            <img
                                class="rounded-circle header-profile-user"
                                src="@/assets/images/users/user-4.jpg"
                                alt="Avatar"
                            />
                          </span>
                            </div>
                            <div class="col-9 justify-content-center">
                              <p v-if="chutri.fullName" class="mb-0 text-black">{{ chutri.fullName }}</p>
                              <div v-if="chutri.email" class="d-flex align-items-center">
                                <i class="mdi mdi-email text-warning me-1"></i>
                                <p class="mb-0">{{ chutri.email }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12 justify-content-center">
                          <p class="mb-0 cs-bg-text"><span class="">{{ chutri.donVi.ten }}</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Thành phần tham dự-->
              <div v-if="chiTietCongViec.thanhPhanThamDu" class="row mb-3">
                <div>
                  <h5 class="text-bold text-black">Thành phần tham dự</h5>
                </div>
                <div v-if="chiTietCongViec.thanhPhanThamDu">
                  <div v-for="(tptd, index) in chiTietCongViec.thanhPhanThamDu" :key="index" class="cs-row">
                    <div class="row equal-height-row ">
                      <div class="col-md-6 col-12">
                        <div class="row equal-height-row">
                          <div class="col-3 justify-content-center">
                      <span v-if="tptd.avatar">
                      <b-img
                          :src=" url + `${tptd.avatar.fileId}`"
                          alt="Avatar"
                          class="rounded-circle header-profile-user"
                      >
                      </b-img>
                    </span>
                            <span v-else>
                      <img
                          class="rounded-circle header-profile-user"
                          src="@/assets/images/users/user-4.jpg"
                          alt="Avatar"
                      />
                    </span>
                          </div>
                          <div class="col-9 justify-content-center">
                            <p v-if="tptd.fullName" class="mb-0 text-black">{{ tptd.fullName }}</p>
                            <div v-if="tptd.email" class="d-flex align-items-center">
                              <i class="mdi mdi-email text-warning me-1"></i>
                              <p class="mb-0 truncate">{{ tptd.email }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12 justify-content-center">
                        <p class="mb-0 cs-bg-text">
                          <span class="">{{ tptd.donVi.ten }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  Thành phần khác-->
              <div v-if="chiTietCongViec.thanhPhan" class="row mb-3">
                <div>
                  <h5 class="text-bold text-black">Thành phần khác</h5>
                </div>
                <div>
                  <p class="mb-0" :inner-html.prop="chiTietCongViec.thanhPhan"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="showModalThanhPhanKhacLCT"
        centered
        title="Chi tiết công việc"
        title-class="font-18"
        no-close-on-backdrop
        size="lg"
        hide-header
        hide-footer
        modal-class="cs-modal-chitietLCT"
    >
      <div class="row">
        <div class="col-12 position-relative">
          <a class="cs-close-modal" @click="showModalThanhPhanKhacLCT = false"><i class="mdi mdi-close-thick"></i></a>
        </div>
      </div>
      <div class="row px-3 mt-3" v-if="chiTietCongViec">
        <div class="col-12 px-4">
          <!-- Thành phần tham dự-->
          <div v-if="chiTietCongViec.thanhPhanThamDu" class="row mb-3">
            <div>
              <h5 class="text-bold text-black">Thành phần tham dự</h5>
            </div>
            <div v-if="chiTietCongViec.thanhPhanThamDu">
              <div v-for="(tptd, index) in chiTietCongViec.thanhPhanThamDu" :key="index" class="cs-row">
                <div class="row equal-height-row ">
                  <div class="col-md-6 col-12">
                    <div class="row equal-height-row">
                      <div class="col-3 justify-content-center">
                      <span v-if="tptd.avatar">
                      <b-img
                          :src=" url + `${tptd.avatar.fileId}`"
                          alt="Avatar"
                          class="rounded-circle header-profile-user"
                      >
                      </b-img>
                    </span>
                        <span v-else>
                      <img
                          class="rounded-circle header-profile-user"
                          src="@/assets/images/users/user-4.jpg"
                          alt="Avatar"
                      />
                    </span>
                      </div>
                      <div class="col-9 justify-content-center">
                        <p v-if="tptd.fullName" class="mb-0 text-black">{{ tptd.fullName }}</p>
                        <div v-if="tptd.email" class="d-flex align-items-center">
                          <i class="mdi mdi-email text-warning me-1"></i>
                          <p class="mb-0 truncate">{{ tptd.email }} </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 justify-content-center">
                    <p class="mb-0 cs-bg-text">
                      <span class="">{{ tptd.donVi.ten }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  Thành phần khác-->
          <div v-if="chiTietCongViec.thanhPhan" class="row mb-3">
            <div>
              <h5 class="text-bold text-black">Thành phần khác</h5>
            </div>
            <div>
              <p class="mb-0" :inner-html.prop="chiTietCongViec.thanhPhan"></p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style>

.title-capso {
  font-weight: bold;
  color: #00568C;
}

.pd-custom-2 {
  padding: 0px 5px;
}
</style>

<style lang="scss">
.card-vanbanden {
  //background: url("~@/assets/images/card-vanbanden.png");
  //background-repeat: no-repeat;
  //background-size: cover;
  //background: linear-gradient(135deg, #308dc7, #6dbdf3);
  //background: rgba(246, 246, 246, 0.13);
  //box-shadow: -3px -3px 5px 2px #fff, 3px 3px 5px 2px #eaeaea;
  box-shadow: 0px 0px 13px 0px rgba(236, 236, 241, 0.44);
  background: #f3fff7;
  min-height: 120px !important;
  height: 100%;

  & .cs-title-start {
    color: #106500 !important;
    text-shadow: 0px 0px 1px #fff;
  }

}

.card-vanbandi {
  //background: url("~@/assets/images/card-vanbandi.png");
  //background-repeat: no-repeat;
  //background-size: cover;
  //background: linear-gradient(135deg, #1b8b9a, #5ac7c7);
  //background: rgba(246, 246, 246, 0.13);
  //box-shadow: -3px -3px 5px 2px #fff, 3px 3px 5px 2px #eaeaea;
  box-shadow: 0px 0px 13px 0px rgba(236, 236, 241, 0.44);
  background: #f6efff;
  min-height: 120px !important;
  height: 100%;

  & .cs-title-start {
    color: #4f05b6 !important;
    text-shadow: 0px 0px 1px #fff;
  }
}

.card-hopthu {
  //background: url("~@/assets/images/card-hopthu.png");
  //background-repeat: no-repeat;
  //background-size: cover;
  //background: linear-gradient(135deg, #c04141, #e59191);
  //background: rgba(246, 246, 246, 0.13);
  //box-shadow: -3px -3px 5px 2px #fff, 3px 3px 5px 2px #eaeaea;
  box-shadow: 0px 0px 13px 0px rgba(236, 236, 241, 0.44);
  background: #fff4f2;
  min-height: 120px !important;
  height: 100%;

  & .cs-title-start {
    color: #e53f19 !important;
    text-shadow: 0px 0px 1px #fff;
  }
}

.card-thongbao {
  //background: url("~@/assets/images/card-thongbao.png");
  //background-repeat: no-repeat;
  //background-size: cover;
  //background: linear-gradient(135deg, #c98e0c, #eab46f);
  //background: rgba(246, 246, 246, 0.13);
  //box-shadow: -3px -3px 5px 2px #fff, 3px 3px 5px 2px #eaeaea;
  box-shadow: 0px 0px 13px 0px rgba(236, 236, 241, 0.44);
  background: #ecf4ff;
  min-height: 120px !important;
  height: 100%;

  & .cs-title-start {
    color: #0b49bd !important;
    text-shadow: 0px 0px 1px #fff;
  }
}

@media (max-width: 768px) {
  .cs-table-dashboard{
    width: 1200px !important;
  }
}
</style>

